import axios from 'axios';
import AppConfig from '../config';

// Development ortamında timeout genişlet
const isDevelopment = process.env.NODE_ENV === 'development';

const api = axios.create({
  baseURL: AppConfig.apiBaseUrl, // From .env: REACT_APP_API_URL
  headers: {
    'Content-Type': 'application/json',
  },
  // Performance optimizations - Development'ta daha uzun timeout
  timeout: isDevelopment ? 30000 : 10000, // Development'ta 30 saniye, production'da 10 saniye
  timeoutErrorMessage: isDevelopment ? 'Development timeout - slow server response' : 'Request timeout - please try again',
});

// Request interceptor for performance monitoring
api.interceptors.request.use(
  (config) => {
    console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for performance monitoring
api.interceptors.response.use(
  (response) => {
    console.log(`✅ API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('❌ Response Error:', error.response?.status, error.config?.url);
    return Promise.reject(error);
  }
);

export default api;
